<div class="dialog-wrapper import-history-detail-dialog">
  <h3 mat-dialog-title>
    {{ 'app.autopilot_devices.history.detail_dialog_title' | translate }}
  </h3>

  <div mat-dialog-content class="dialog-content">
    @if (entry.metadata.error) {
      <div class="error-message">
        <mat-icon>warning</mat-icon>
        <span>{{ entry.metadata.error }}</span>
      </div>
    }
    @if (deviceStateEntries().length > 0) {
      <table class="device-status-table">
        <thead>
          <tr>
            <th>
              {{ 'app.autopilot_devices.history.device_table.import_status' | translate }}
            </th>
            <th>{{ 'app.autopilot_devices.history.device_table.error_code' | translate }}</th>
            <th>{{ 'app.autopilot_devices.history.device_table.error_name' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (device of deviceStateEntries(); track device.id) {
            <tr>
              <td>
                <span class="status-badge small" [ngClass]="getDeviceStatusClass(device.state)">
                  {{ getImportStatusKey(device.state.deviceImportStatus) | translate }}
                </span>
              </td>
              <td>{{ device.state.deviceErrorCode }}</td>
              <td>{{ translateErrorName(device.state.deviceErrorName) }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p class="no-devices">
        {{ 'app.autopilot_devices.history.no_devices_in_import' | translate }}
      </p>
    }
  </div>

  <div mat-dialog-actions>
    <div class="dialog-actions">
      <button mat-flat-button color="primary" (click)="close()">
        {{ 'shared.general.buttons.close' | translate }}
      </button>
    </div>
  </div>
</div>
